import { useState } from 'react';
export var useChannelsQueryState = function () {
    var _a = useState(null), error = _a[0], setError = _a[1];
    var _b = useState('uninitialized'), queryInProgress = _b[0], setQueryInProgress = _b[1];
    return {
        error: error,
        queryInProgress: queryInProgress,
        setError: setError,
        setQueryInProgress: setQueryInProgress,
    };
};
